export const pendingApprovalDesignsApiPageSelector = (state, page) => {
  return state.api.designs.personal.approvals.pendingApproval.pages[page];
};

export const pendingApprovalDesignsApiSelector = (state, page) => {
  return state.api.designs.personal.approvals.pendingApproval;
};
